// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"86abf545","801":"4a8bbbee"}[chunkId] + ".chunk.css";
};